module.exports = __webpack_public_path__ + "static/texture-otis-redding-9befbfcfd41cca3886d29e15d6bbfa38.png";